/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

import { useDebounce } from '../../shared/hooks';
import { ParceirosService } from '../services/api/cadastros/ParceirosService';
import { EstoqueOperacoesService } from '../services/api/estoque/estoqueOperacoes/EstoqueOperacoesService';

type TAutoCompleteOption = {
  idoperacoes: string;
  label: string;
  faturamento: boolean;
  tpag: number;
} 
interface IAutoCompleteParceiroProps {
  isExternalLoading?: boolean;
  uuidoperacoes?: (novoTextoselect: string | undefined) => void;
  tipo: number;
}  

export const AutoCompleteOperacoesListagem: React.FC<IAutoCompleteParceiroProps> = ({ isExternalLoading = false, uuidoperacoes, tipo}) => {

  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>('');

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

    useEffect(() => {
      setIsLoading(true);
  
      debounce(() => {
        EstoqueOperacoesService.getAlllist(busca, selectedId, tipo)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              // alert(result.message);
            } else {
              setOpcoes(result.data.map(operacoes => ({ idoperacoes: operacoes.idoperacoes, label: operacoes.descricao, operacao: operacoes.descricao,  faturamento: operacoes.faturamento, tpag: operacoes.tpag})));
            }
          });
      });
    }, [busca, selectedId]);
 
  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idoperacoes === selectedId); 
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);
   
  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      size='small'
      fullWidth
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      // Só busca sozinho por `reason==='input'` — ver AutoCompleteMunicipio.tsx pro caso
      // completo do loop que isso evita (reset automático do MUI virando busca).
      onInputChange={(_, newValue, reason) => {
        if (reason === 'input') setBusca(newValue);
      }}
      onChange={(_, newValue) => { setSelectedId(newValue?.idoperacoes);  uuidoperacoes?.(newValue?.idoperacoes);  setBusca('');  }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}

          label="Operações"
          // error={!!error}  
          // helperText={error}
        />
      )}
    />
  );
};